import React, { Component } from 'react';
import { FormGroup, FormFeedback, Input, Row, Col, Label} from 'reactstrap';

import * as FormLogic from './FormLogic'
import { run } from '../validation/validationRunner'

const fieldValidations = [
]

class RegistrationFormFreeFieldData extends Component {
  constructor(props) {
    super(props);
    this.validate = false;
    this.state = {
      validationErrors: [],
      fieldsTouched: [],
      FreeFieldValue1: "",
      FreeFieldValue2: ""
    };

    this.handleChange = FormLogic.handleChange.bind(this);
    this.errorFor = FormLogic.errorFor.bind(this);
    this.setFieldsTouched = FormLogic.setFieldsTouched.bind(this);
    this.run = run.bind(this);
  }

  componentDidUpdate() {
    this.runValidations();
  }

  runValidations(ignoreTouched) {
    if (ignoreTouched) {
      this.validate = true;
    }
    return this.run(fieldValidations);
  }

  getFormValues() {
    return {
      "FreeFieldValue1" : this.state.FreeFieldValue1,
      "FreeFieldValue2" : this.state.FreeFieldValue2
    }
  }

  render() {
    return (
      <div>
        <Row>
          <Col md={{size:3, offset:1}} />
          <Col md={7}>
            <h2>
              Aanvullende vragen van de vereniging
            </h2>
          </Col>
        </Row>

        <FormGroup row hidden={!this.props.freeFieldData.DescriptionFreeDropDown1}>
          <Col md={{size:3, offset:1}} >
            <Label className="Label">{this.props.freeFieldData.DescriptionFreeDropDown1}</Label>
          </Col>
          <Col md={7}>
            <Input
              name="FreeFieldValue1"
              type="select"
              value={this.state.FreeFieldValue1}
              onChange={this.handleChange}
              onBlur={this.setFieldsTouched}
              className="Input">
            {this.props.freeFieldData.FreeFieldValues1.map((freeFieldValue) =>
              <option key={freeFieldValue.Id} value={freeFieldValue.Id}>
                {freeFieldValue.Description}
              </option>)  }
            </Input>
            <FormFeedback>{this.errorFor("FreeFieldValue1")}</FormFeedback>
          </Col>
        </FormGroup>

        <FormGroup row hidden={!this.props.freeFieldData.DescriptionFreeDropDown2}>
          <Col md={{size:3, offset:1}} >
            <Label className="Label">{this.props.freeFieldData.DescriptionFreeDropDown2}</Label>
          </Col>
          <Col md={7}>
            <Input
              name="FreeFieldValue2"
              type="select"
              value={this.state.FreeFieldValue2}
              onChange={this.handleChange}
              onBlur={this.setFieldsTouched}
              className="Input">
            {this.props.freeFieldData.FreeFieldValues2.map((freeFieldValue) =>
              <option key={freeFieldValue.Id} value={freeFieldValue.Id}>
                {freeFieldValue.Description}
              </option>)  }
            </Input>
            <FormFeedback>{this.errorFor("FreeFieldValue2")}</FormFeedback>
          </Col>
        </FormGroup>

      </div>
    );
  }
}

export default RegistrationFormFreeFieldData



// WEBPACK FOOTER //
// ./src/registrationform/RegistrationFormFreeFieldData.jsx